var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 3.50078C6.44782 3.50078 6.73443 3.70735 6.83651 4.01361L7.93668 7.3141L11.2372 8.41427C11.5434 8.51635 11.75 8.80296 11.75 9.12578C11.75 9.4486 11.5434 9.73521 11.2372 9.83729L7.93668 10.9375L6.83651 14.238C6.73443 14.5442 6.44782 14.7508 6.125 14.7508C5.80218 14.7508 5.51557 14.5442 5.41349 14.238L4.31332 10.9375L1.01283 9.83729C0.706573 9.73521 0.5 9.4486 0.5 9.12578C0.5 8.80296 0.706573 8.51635 1.01283 8.41427L4.31332 7.3141L5.41349 4.01361C5.51557 3.70735 5.80218 3.50078 6.125 3.50078ZM6.125 6.62249L5.61776 8.1442C5.54311 8.36816 5.36737 8.54389 5.14342 8.61854L3.62171 9.12578L5.14342 9.63302C5.36737 9.70767 5.54311 9.88341 5.61776 10.1074L6.125 11.6291L6.63224 10.1074C6.70689 9.88341 6.88263 9.70767 7.10658 9.63302L8.62829 9.12578L7.10658 8.61854C6.88263 8.54389 6.70689 8.36816 6.63224 8.1442L6.125 6.62249Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.125 0.800781C12.3187 0.800781 12.4907 0.924725 12.5519 1.10848L13.137 2.86377L14.8923 3.44887C15.0761 3.51012 15.2 3.68209 15.2 3.87578C15.2 4.06947 15.0761 4.24144 14.8923 4.30269L13.137 4.88779L12.5519 6.64308C12.4907 6.82684 12.3187 6.95078 12.125 6.95078C11.9313 6.95078 11.7593 6.82684 11.6981 6.64308L11.113 4.88779L9.3577 4.30269C9.17394 4.24144 9.05 4.06947 9.05 3.87578C9.05 3.68209 9.17394 3.51012 9.3577 3.44887L11.113 2.86378L11.6981 1.10848C11.7593 0.924725 11.9313 0.800781 12.125 0.800781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWhite);
export default __webpack_public_path__ + "static/media/star_white.cbc9a18f31dd3bf19181f9c920f8d2dd.svg";
export { ForwardRef as ReactComponent };